import { useOptionsRight } from 'global/cnr/contexts/useHelpers/useOptionsRight';
import _ from 'lodash';
import { Suspense, useContext, useEffect, useReducer, useState } from 'react';
import { Icon, Menu, Sidebar } from 'semantic-ui-react';
import { _useAppSlimMode } from '../../App';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { PageContext } from '../cnr/contexts/PageContext';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { rightMenuHandlers, rightMenuReducer, rightMenuTriggerTypes, rightMenuTypes } from '../cnr/reducers/RightMenuReducer';
import { defaultHelpers, withDefaultProps } from '../common/defaultProps';
import { uniqueKey } from "../common/keys";
import SuspenseDimmer from '../components/alerts/SuspenseDimmer';
import { openExternal } from '../viewSettings/helpers/settingsLinks';
import TransitionWrapper, { transitionWrapperTypes } from '../wrappers/TransitionWrapper';

const SettingsAppRightMenu = (props) => {

  const { allowSideData } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { currentSettings_state, paps_state } = states
  const { appSettings_handlers } = handlers
  const { pathModes, view } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { projectOptions, themeColors } = aps_global ?? {}
  const { useEventGutterText, eventGutterText, eventPoweredByText, ignorePoweredBy } = projectOptions ?? {}
  const { color1 } = themeColors ?? {}

  // pageContext
  const pageContext = useContext(PageContext)
  const { homeSettings_global } = pageContext ?? {}
  const { settingsOptions } = homeSettings_global ?? {}
  const { useGutterText, gutterText, poweredByText } = settingsOptions ?? {}

  const _useGutterText = _useAppSlimMode ? false : useEventGutterText || useGutterText
  const _gutterText = eventGutterText || gutterText
  const _poweredByText = eventPoweredByText ? eventPoweredByText : poweredByText

  const hexToRGBA = (hex, opacity) => {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const gutterStyle = useEventGutterText ? {
    background: `linear-gradient(to bottom, ${color1}, ${hexToRGBA(color1, 0)})`
  } : {};

  let _gutterClass = 'app-me'

  if (!ignorePoweredBy) {
    _gutterClass += ' pb'
  }

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_handlers, framework_state } = frameworkContext ?? {}
  const { pathViews: pathViews_fw, showRightMenuCaptions } = framework_state ?? {}

  const [showMenuItems, setShowMenuItems] = useState(false)
  const [menuVisible, setMenuVisible] = useState(false);

  let dashboardType;

  if (pathModes.sport) {
    dashboardType = 'Sports'
  } else if (pathModes.district) {
    dashboardType = 'District'
  } else if (pathModes.organization) {
    dashboardType = 'Organization'
  }

  const initState = {}
  const [rightMenu_state, rightMenu_dispatch] = useReducer(rightMenuReducer, initState);
  const rightMenu_handlers = rightMenuHandlers(rightMenu_dispatch)
  const { currentMenuType, triggerActionType, frt, dmt, frv } = rightMenu_state ?? {}
  const { handleSet_currentMenuType } = rightMenu_handlers ?? {}

  const rightOptions = useOptionsRight({ rightMenu_handlers, allowSideData })

  useEffect(() => {
    switch (currentMenuType) {
      case rightMenuTypes.propsOverride:
      case rightMenuTypes.subActions:
        setShowMenuItems(true)
        break;

      default:
        // this is the default
        setShowMenuItems(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentMenuType]);

  useEffect(() => {
    if (triggerActionType) {
      switch (triggerActionType) {
        case rightMenuTriggerTypes.toggle:
          framework_handlers.handleToggle_rightMenu()
          break;
        case rightMenuTriggerTypes.frameworkRight:
          framework_handlers.handleShow_frameworkRight(view, frt, dmt, frv)
          break;
        case rightMenuTriggerTypes.openDb:
          openExternal.db(pathViews_fw, null, [view, pathViews_fw?.[view]])
          break;
        case rightMenuTriggerTypes.settings:
          framework_handlers.handleShow_frameworkRight(view, triggerActionType)
          // appSettings_handlers.handleToggle_settingsRightOn()
          break;
        case rightMenuTriggerTypes.propsSave:
          framework_handlers.handleUpdate_propsFromToggled()
          break;
        case rightMenuTriggerTypes.directLinksOverride:
          appSettings_handlers.handleDirectLinksOverride()
          break;

        // case rightMenuTriggerTypes.dashboard:
        //   framework_handlers.handleShow_appDashboard(frt)
        //   break;

        default:
        // nothing
      }
      handleSet_currentMenuType()
    }
    appSettings_handlers.handlePropOverride(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerActionType]);

  useEffect(() => {
    switch (currentMenuType) {
      case rightMenuTypes.propsOverride:
        appSettings_handlers.handlePropOverride(true)
        break;
      default:
        appSettings_handlers.handlePropOverride(false)
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMenuType]);

  const icon = (item) => {
    const { icon, color, iconCorner, iconCornerColor, disabled } = withDefaultProps(item, defaultHelpers.iconDefaults);
    if (iconCorner) {
      return <Icon.Group>
        <Icon name={icon} color={color ? color : null} />
        <Icon corner name={iconCorner} color={iconCornerColor ? iconCornerColor : 'blue'} />
      </Icon.Group>
    } else {
      return <Icon name={icon} color={color ? color : null} disabled={disabled} />
    }
  }

  const menuItems = (opts, forData) => {
    const mis = _.map(opts, (item, key) => {
      const { caption, disabled, text, oc, frt, frv, rmt, dmt, showCaption, dividerBefore, headerBefore } = item
      let cn = dividerBefore ? 'sbm-top' : ''
      if (headerBefore) { cn += ' hdr' }
      const _caption = showRightMenuCaptions || showCaption ? text : caption
      if (_caption) { cn += ' left-sub' }
      if (forData) { cn += ' dat' }
      return <Menu.Item
        key={uniqueKey('svs', 'mi', key)}
        name={_caption}
        onClick={() => oc && oc({ frt, rmt, dmt, frv })}
        title={text}
        disabled={disabled}
        className={cn || null}
      >
        {icon(item)}
        {_caption && _caption}
      </Menu.Item>
    })
    return mis
  }

  const menu_selected = () => {
    const divs = []
    switch (currentMenuType) {
      case rightMenuTypes.propsOverride:
        divs.push(<div>{menuItems(rightOptions.propz)}</div>)
        break;
      case rightMenuTypes.subActions:
        divs.push(<div>{menuItems(rightOptions.subActions)}</div>)
        break;
    }
    return <Menu inverted icon vertical fixed="right" className='frm-right menu-sarm'>
      {divs}
    </Menu>
  }

  const menu_main = () => {
    return <TransitionWrapper transitionWrapperType={transitionWrapperTypes.basic}>
      <Menu
        inverted
        icon
        vertical
        className='frm-right sarm'
        style={{
          opacity: menuVisible ? 1 : 0,
          pointerEvents: menuVisible ? 'auto' : 'none',
          transition: 'opacity 0.5s ease',
        }}
      >
        <div>
          {menuItems(rightOptions?.page)}
          {menuItems(rightOptions?.data, true)}
          {rightOptions?.subAction && rightOptions.subAction.length > 0 && menuItems(rightOptions?.subAction, true)}
        </div>
        <div>{menuItems(rightOptions?.home)}</div>
      </Menu>
      {_useGutterText && _gutterText &&
        <div
          className={_gutterClass}
          style={gutterStyle}
        >
          <div>{_gutterText}</div>
          {!ignorePoweredBy && <div>{_poweredByText ? _poweredByText : 'Powered by Meeting Evolution'}</div>}
        </div>
      }
    </TransitionWrapper>
  }

  let cn = 'sbr-psh-r'

  if (showMenuItems) {
    cn += ' vw'
  }

  const sidebar = () => <Sidebar.Pushable className={cn} >
    {showMenuItems && menu_selected()}
    <Sidebar.Pusher
      onMouseEnter={() => setMenuVisible(true)}
      onMouseLeave={() => setMenuVisible(false)}
      dimmed={showMenuItems}
      className={'h100'}
    >
      {menu_main()}
    </Sidebar.Pusher>
  </Sidebar.Pushable>

  return <Suspense fallback={<SuspenseDimmer caption={'appSub'} origin={'SettingsAppRightMenu'} />}>
    {rightOptions ? sidebar() : <div></div>}
  </Suspense>

}

export default SettingsAppRightMenu